// Standard HTTP Status Codes
export const HTTP_STATUS = {
    // Custom/Application Specific
    NO_RESPONSE: 0,
    LINKEDIN_ERROR: 999,

    // Success Codes
    OK: 200,
    CREATED: 201,
    ACCEPTED: 202,

    // Redirection
    MOVED_PERMANENTLY: 301,
    FOUND: 302,
    TEMPORARY_REDIRECT: 307,
    PERMANENT_REDIRECT: 308,

    // Client Errors
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    TOO_MANY_REQUESTS: 429,

    // Server Errors
    INTERNAL_SERVER_ERROR: 500,
    BAD_GATEWAY: 502,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMEOUT: 504,

    // Cloudflare Specific
    CF_UNKNOWN_ERROR: 520,
    CF_WEB_SERVER_DOWN: 521,
    CF_CONNECTION_TIMEOUT: 522,
    CF_ORIGIN_UNREACHABLE: 523,
    CF_TIMEOUT: 524,
    CF_SSL_HANDSHAKE_FAILED: 525,
    CF_INVALID_SSL: 526,
    CF_RAILGUN_ERROR: 527,
    CF_ORIGIN_DNS_ERROR: 530
};

// Array of all status codes for dropdown/select options
export const STATUS_CODES = [
    { value: HTTP_STATUS.NO_RESPONSE, label: 'No Response' },
    { value: HTTP_STATUS.OK, label: 'OK' },
    { value: HTTP_STATUS.CREATED, label: 'Created' },
    { value: HTTP_STATUS.ACCEPTED, label: 'Accepted' },
    { value: HTTP_STATUS.MOVED_PERMANENTLY, label: 'Moved Permanently' },
    { value: HTTP_STATUS.FOUND, label: 'Found/Moved Temporarily' },
    { value: HTTP_STATUS.TEMPORARY_REDIRECT, label: 'Temporary Redirect' },
    { value: HTTP_STATUS.PERMANENT_REDIRECT, label: 'Permanent Redirect' },
    { value: HTTP_STATUS.BAD_REQUEST, label: 'Bad Request' },
    { value: HTTP_STATUS.UNAUTHORIZED, label: 'Unauthorized' },
    { value: HTTP_STATUS.FORBIDDEN, label: 'Forbidden' },
    { value: HTTP_STATUS.NOT_FOUND, label: 'Not Found' },
    { value: HTTP_STATUS.TOO_MANY_REQUESTS, label: 'Too Many Requests' },
    { value: HTTP_STATUS.INTERNAL_SERVER_ERROR, label: 'Internal Server Error' },
    { value: HTTP_STATUS.BAD_GATEWAY, label: 'Bad Gateway' },
    { value: HTTP_STATUS.SERVICE_UNAVAILABLE, label: 'Service Unavailable' },
    { value: HTTP_STATUS.GATEWAY_TIMEOUT, label: 'Gateway Timeout' },
    { value: HTTP_STATUS.CF_UNKNOWN_ERROR, label: 'Unknown Error (CF)' },
    { value: HTTP_STATUS.CF_WEB_SERVER_DOWN, label: 'Web Server Down (CF)' },
    { value: HTTP_STATUS.CF_CONNECTION_TIMEOUT, label: 'Connection Timeout (CF)' },
    { value: HTTP_STATUS.CF_ORIGIN_UNREACHABLE, label: 'Origin Unreachable (CF)' },
    { value: HTTP_STATUS.CF_TIMEOUT, label: 'Timeout (CF)' },
    { value: HTTP_STATUS.CF_SSL_HANDSHAKE_FAILED, label: 'SSL Handshake Failed (CF)' },
    { value: HTTP_STATUS.CF_INVALID_SSL, label: 'Invalid SSL Certificate (CF)' },
    { value: HTTP_STATUS.CF_RAILGUN_ERROR, label: 'Railgun Error (CF)' },
    { value: HTTP_STATUS.CF_ORIGIN_DNS_ERROR, label: 'Origin DNS Error (CF)' },
    { value: HTTP_STATUS.LINKEDIN_ERROR, label: 'LinkedIn Error' }
]; 